import { render, staticRenderFns } from "./entradaGeral.vue?vue&type=template&id=12fad587&scoped=true&"
import script from "./entradaGeral.vue?vue&type=script&lang=js&"
export * from "./entradaGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fad587",
  null
  
)

export default component.exports